import { FC, useMemo } from 'react';

import { CartLineItem } from '@/types';
import { useActiveProductBadges } from 'hooks/useActiveProductBadges';
import { ProductBadge } from '@/components';

interface IProductValidatorBadges {
  product: CartLineItem;
  badgeClass?: string;
}

const ProductValidatorBadges: FC<IProductValidatorBadges> = ({
  product,
  badgeClass,
}) => {
  const { badges, shouldRender } = useActiveProductBadges({
    product,
    weightVariant: product?.weightVariant,
    badgeClass,
  });

  const renderedBadges = useMemo(
    () =>
      badges.map(({ props }, index) => <ProductBadge {...props} key={index} />),
    [badges],
  );

  if (!shouldRender || badges.length === 0) return null;

  return <>{renderedBadges}</>;
};

export { ProductValidatorBadges };
